const initialState = {
  // Initial state for toast
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle toast-related actions if needed
    default:
      return state;
  }
};

export default toastReducer;
